"use client";

/**
 * Guest theme rotation — PERMANENTLY DISABLED.
 * Visitors see a stable theme; they discover the theme picker themselves.
 * The Super Admin "Guest Theme Rotation" toggle is ignored.
 */
export function useGuestThemeRotation() {
  // no-op: rotation has been disabled at Gordon's request
}
